import packageJson from '../../../package.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
const LIBRARY_VERSION = packageJson.version;
const DEFAULT_COOKIE_EXPIRY_DAYS = 730;
const DAILY_SECONDS = 86400;
const API_VERSION = 'v1.2';
const CALLFLOW_API_VERSION = 'v2';
const UTM_PREFIX = 'utm_';
const BID_PREFIX = 'bid_';
const MAX_EXT_ATTRIBUTES = 50;
var EndPoint;
(function (EndPoint) {
    EndPoint["Events"] = "events";
    EndPoint["Browser"] = "browser";
    EndPoint["Batches"] = "batches";
    EndPoint["CallFlows"] = "callFlows";
})(EndPoint || (EndPoint = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes["Add"] = "ADD";
    EventTypes["AddConsumers"] = "ADD_CONSUMERS";
    EventTypes["AddContacts"] = "ADD_CONTACTS";
    EventTypes["AddProduct"] = "ADD_PRODUCT";
    EventTypes["Calculator"] = "CALCULATOR";
    EventTypes["CampaignTracking"] = "CAMPAIGN_TRACKING";
    EventTypes["ClearCart"] = "CLEAR_CART";
    EventTypes["Click"] = "CLICK";
    EventTypes["Chat"] = "CHAT";
    EventTypes["Checkout"] = "CHECKOUT";
    EventTypes["Comment"] = "COMMENT";
    EventTypes["Confirm"] = "CONFIRM";
    EventTypes["ContactRequest"] = "CONTACT_REQUEST";
    EventTypes["Consumers"] = "CONSUMERS";
    EventTypes["Email"] = "EMAIL";
    EventTypes["Login"] = "LOGIN";
    EventTypes["Identity"] = "IDENTITY";
    EventTypes["Notification"] = "NOTIFICATION";
    EventTypes["OrderUpdate"] = "ORDER_UPDATE";
    EventTypes["Payment"] = "PAYMENT";
    EventTypes["Purchase"] = "PURCHASE";
    EventTypes["PnrRecord"] = "PNR_RECORD";
    EventTypes["Sms"] = "SMS";
    EventTypes["Subscription"] = "SUBSCRIPTION";
    EventTypes["Search"] = "SEARCH";
    EventTypes["Select"] = "SELECT";
    EventTypes["Trigger"] = "TRIGGER";
    EventTypes["TripSummary"] = "TRIP_SUMMARY";
    EventTypes["Update"] = "UPDATE";
    EventTypes["View"] = "VIEW";
})(EventTypes || (EventTypes = {}));

export { API_VERSION, BID_PREFIX, CALLFLOW_API_VERSION, DAILY_SECONDS, DEFAULT_COOKIE_EXPIRY_DAYS, EndPoint, EventTypes, LIBRARY_VERSION, MAX_EXT_ATTRIBUTES, UTM_PREFIX };
